import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XlMapperComponent } from './xl-mapper.component';

const routes: Routes = [{ path: 'xlMapper', component: XlMapperComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class XlMapperRoutingModule { }
